import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=2895c7a4&scoped=true&"
import script from "./forgetPassword.vue?vue&type=script&lang=js&"
export * from "./forgetPassword.vue?vue&type=script&lang=js&"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=2895c7a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2895c7a4",
  null
  
)

export default component.exports